import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className='not-found'>
            <h2 className='text-6xl'>404</h2>
            <p>Page Not Found!!</p>
        </div>
    );
};

export default NotFound;